<template>
    <div>
        <div class="text-h6 ml-1 my-4 font-weight-bold black--text">{{title}}</div>
        <v-list three-line style="background-color: #f5f5f5" v-if="this.addresses.length">
            <v-list-item-group v-model="selectedAddress">
                <v-list-item class="box-border" v-for="(address, index) in addresses" :key="index" :value="address">
                    <v-list-item-action>
                        <v-icon>mdi-clock-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{address.name}}</v-list-item-title>
                        <v-list-item-subtitle>{{ buildAddressPreview(address) }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{address.contactNo}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        <v-btn :style="theme" outlined :block="isMobile ? true : false" @click="$refs.addressDialog.toggleDialog(true)" v-if="showAddNewBtn" >Add Shipping Address</v-btn>
        <address-form :address="selectedAddress" @success="addNewAddress($event)" ref="addressDialog"
            @cancel="$refs.addressDialog.toggleDialog()"></address-form>
    </div>
</template>

<script>
import AddressForm from './AddressForm.vue'
export default {
  components: { AddressForm },
    props: {
        addresses: {
            type: Array,
            default: () => []
        },
        title:{
            type: String,
            default: () => "Available Addresses"
        },
        value:{
            type: [String, Object],
            default: () => undefined
        },
        showAddNewBtn: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        selectedAddress:{
            get() {
                return this.value 
            },
            set(value){
                this.$emit('input', value)
            }
        }
    },
    methods: {
        async addNewAddress(address) {
            try {
                this.addresses.push(address)
                this.selectedAddress = address
                this.$emit('newAddress', address)
                this.$refs.addressDialog.toggleDialog()
            } catch (error) {
               this.handleError(error)
            }
        }
    },
}
</script>

<style scoped>
.box-border{
    margin: 0.5% 0%;
}
</style>